import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";
import ProductCompareController from "Fratello/ProductCompare/Controllers/ProductController";

export default function ProductView(props) {
    const {
        title,
        url,
        thumb,
        price,
        originalPrice,
        properties,
        compare,
        compareUrl
    } = props;
    const Price = ComponentRegistry.get("Price");
    const Image = ComponentRegistry.get("Image");

    // const incentives = Object.values(properties.incentives.value)
    //     .map(incentive => <span className="item-incentive" key={incentive.id}>{incentive.title}</span>);

    return (
      <article className="product-item list-item col-lg-3 col-md-4 col-sm-6 col-xs-12" itemType="http://schema.org/Product">
        <a className="clearfix" href={url}>
          <div className="item-visual">

            <Image className="img-fluid" src={thumb} alt={title} />
            {/*<div className="item-incentives">{incentives}</div>*/}
            <ProductCompareController id={title.replace(/\s/g,'')} url={compareUrl} {...compare} product={props} />
          </div>
          <div>
            <p className="product-description" itemProp="name">{title}</p>
            {/*<Price value={price.excl} originalValue={originalPrice.excl} />*/}
          </div>
        </a>
      </article>
    );
}

ProductView.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    thumb: PropTypes.string,
    price: PropTypes.shape({
        excl: PropTypes.string.isRequired,
    }).isRequired,
    originalPrice: PropTypes.shape({
        excl: PropTypes.string.isRequired,
    }),
    properties: PropTypes.shape({}).isRequired,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Views/ThumbView.jsx